<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="!readonly"
      unit="学生信息"
      edit-title
      id-key="TeachersTeachingId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">        
        <el-row>
          <el-col :span="12">
            <el-form-item label="学生姓名" prop="Teacher">
              <!-- <el-input size="mini" v-model="data.Teacher" placeholder="点击选择" readonly @focus="onSTDialog"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="科目" prop="Subject">
              <el-select v-model="data.Subject" size="small">
                <el-option v-for="item in subList" :key="item.SubjectId" :value="item.Subject"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学期名称" prop="TermName">
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <teacher-dialog ref="teacherDialog" in-dialog selectable :multiple="false" @select="setTeacher" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import teacherDialog from "@/components/sys/teacher/listDialog"
import termApi from "@/api/ed/term";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    teacherDialog,
  },
  data() {
    return {
      data: {
        TeachersTeachingId: 0,
        TermId: 0,
        TermNumber: "",
        TeacherId: 0,
        Teacher: "",
        Subject: "",
        ClassId: 0
      },
      api: require("@/api/ed/teach").default,
      subApi: require("@/api/ed/subject").default,
      termApi,
      readonly: false,
      subList: [],
      termList: [],
      rules: {
        Teacher: [{ required: true, message: "请选择教师" }],
        Subject: [{ required: true, message: "请选择科目" }],
        TermNumber: [{ required: true, message: "请选择学期" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(row) {
      this.data.ClassId = Number(sessionStorage.getItem("classId")) || 0
      this.data.TermId = Number(sessionStorage.getItem("termId")) || 0
      this.getOption()
    },
    onEditOpened(row) {
      console.log(row)
      this.getOption()
    },
    onDetailsOpened(row) {
      this.onEditOpened(row)
    },
    getOption() {
      this.subApi.list({PageSize:100,PageIndex:1}).then(res => {
        this.subList = res.Data || []
      })
      this.termApi.list().then(res => {
        this.termList = res.Data || []
        this.data.TermId = Number(sessionStorage.getItem("termId"))
      })
    },
    onBeforeSave() {
      // console.log(this.data)
      // return false
    },
    onTeacherDialog() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    setTeacher(t) {
      this.data.TeacherId = t.TeacherId
      this.data.Teacher = t.TeacherName
    },
  },
};
</script>
<style lang="scss">
</style>